import { FunctionComponent } from 'react';
import { GovernmentOverlaysBrickDataDisclaimerModalContentWithData } from './GovernmentOverlaysBrickDataDisclaimerModalContent/GovernmentOverlaysBrickDisclaimerModalContent';
import { DialogModal } from '../../../../../app-kit/components/DialogModal/DialogModal';

interface PropertyPageDataDisclaimerModal {
  opened: boolean;
  onClose: () => void;
  noMargins?: boolean;
}

export const GovernmentOverlaysBrickDataDisclaimerModal: FunctionComponent<
  PropertyPageDataDisclaimerModal
> = ({ opened, onClose }) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
      title="About this data"
    >
      <GovernmentOverlaysBrickDataDisclaimerModalContentWithData />
    </DialogModal>
  );
};
